import {useEffect, useState} from "react";

import {useIsMounted} from "@pg-mono/hooks";
import {navigationHeight} from "@pg-rp/navigation";

import {useInvestmentOfferFilters} from "../../investment_offer/hooks/use_investment_offer_filters";
import {useInvestmentOfferViewsUrl} from "../../investment_offer/hooks/use_investment_offer_views_url";
import {InvestmentOfferListDesktopFilters} from "../../investment_offer/list/components/InvestmentOfferListDesktopFilters";
import {useAppSelector} from "../../store/hooks";
import {WideContentStyled, Wrapper} from "./OfferListViewNavigation";

export const doubleNavHeight = 2 * navigationHeight;

interface IProps {
    setInvestmentOffersBlendActive: (active: boolean) => void;
    isMap?: boolean;
}

export const InvestingOfferListViewNavigation = (props: IProps) => {
    const {listUrl} = useInvestmentOfferViewsUrl();
    const {formValues: filtersFormValues, onChange: onFiltersChange} = useInvestmentOfferFilters();
    const isMounted = useIsMounted();
    const navigationState = useAppSelector((state) => state.navigation.pinState);
    const [isScrollLowerThanDoubleNavHeight, setIsScrollLowerThanDoubleNavHeight] = useState(true);

    const getScrollPosition = () => {
        if (window.scrollY < doubleNavHeight !== isScrollLowerThanDoubleNavHeight) {
            setIsScrollLowerThanDoubleNavHeight(typeof window !== "undefined" ? window.scrollY < doubleNavHeight : true);
        }
    };
    useEffect(() => {
        window.addEventListener("scroll", getScrollPosition);
        return () => window.removeEventListener("scroll", getScrollPosition);
    }, []);

    return (
        <Wrapper navigationState={navigationState} isMounted={isMounted}>
            <WideContentStyled navigationState={navigationState} isInvestment>
                <InvestmentOfferListDesktopFilters
                    onChange={(newFiltersValue) => onFiltersChange(newFiltersValue, true)}
                    setInvestmentOffersBlendActive={props.setInvestmentOffersBlendActive}
                    values={filtersFormValues}
                    isMap={!!props.isMap}
                    listUrl={listUrl}
                />
            </WideContentStyled>
        </Wrapper>
    );
};
import {useEffect, useState} from "react";

import {useIsMounted} from "@pg-mono/hooks";
import {navigationHeight} from "@pg-rp/navigation";

import {useInvestmentOfferFilters} from "../../investment_offer/hooks/use_investment_offer_filters";
import {useInvestmentOfferViewsUrl} from "../../investment_offer/hooks/use_investment_offer_views_url";
import {InvestmentOfferListDesktopFilters} from "../../investment_offer/list/components/InvestmentOfferListDesktopFilters";
import {useAppSelector} from "../../store/hooks";
import {WideContentStyled, Wrapper} from "./OfferListViewNavigation";

export const doubleNavHeight = 2 * navigationHeight;

interface IProps {
    setInvestmentOffersBlendActive: (active: boolean) => void;
    isMap?: boolean;
}

export const InvestingOfferListViewNavigation = (props: IProps) => {
    const {listUrl} = useInvestmentOfferViewsUrl();
    const {formValues: filtersFormValues, onChange: onFiltersChange} = useInvestmentOfferFilters();
    const isMounted = useIsMounted();
    const navigationState = useAppSelector((state) => state.navigation.pinState);
    const [isScrollLowerThanDoubleNavHeight, setIsScrollLowerThanDoubleNavHeight] = useState(true);

    const getScrollPosition = () => {
        if (window.scrollY < doubleNavHeight !== isScrollLowerThanDoubleNavHeight) {
            setIsScrollLowerThanDoubleNavHeight(typeof window !== "undefined" ? window.scrollY < doubleNavHeight : true);
        }
    };
    useEffect(() => {
        window.addEventListener("scroll", getScrollPosition);
        return () => window.removeEventListener("scroll", getScrollPosition);
    }, []);

    return (
        <Wrapper navigationState={navigationState} isMounted={isMounted}>
            <WideContentStyled navigationState={navigationState} isInvestment>
                <InvestmentOfferListDesktopFilters
                    onChange={(newFiltersValue) => onFiltersChange(newFiltersValue, true)}
                    setInvestmentOffersBlendActive={props.setInvestmentOffersBlendActive}
                    values={filtersFormValues}
                    isMap={!!props.isMap}
                    listUrl={listUrl}
                />
            </WideContentStyled>
        </Wrapper>
    );
};
